export default "__VITE_ASSET__CoGGiVbD__"